var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"header-container"},[_c('v-layout',{attrs:{"column":"","align-content-start":""}},[_c('img',{staticClass:"header-logo",attrs:{"src":require("../../../../static/2dsearch-ai/2dSearch-ai-logo.svg"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"divider-line divider-line-blue header-divider"})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9dba4ce","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/searchAi/SearchAIHeader.vue
// module id = null
// module chunks = 